import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide']
  static values = { interval: Number }

  connect() {
    this.currentIndex = 0
    this.slides = this.slideTargets

    // 初期状態：全てのスライドを非表示に
    this.slides.forEach(slide => {
      slide.classList.add('hidden')
      slide.classList.remove('visible')
    })

    // 2つ以上のスライドがある場合のみローテーションを開始
    if (this.slides.length > 1) {
      this.startRotation()
    } else if (this.slides.length === 1) {
      // スライドが1つだけの場合は表示
      this.slides[0].classList.add('visible')
      this.slides[0].classList.remove('hidden')
    }
  }

  disconnect() {
    this.stopRotation()
  }

  startRotation() {
    // 最初のスライドを表示
    this.slides[this.currentIndex].classList.add('visible')
    this.slides[this.currentIndex].classList.remove('hidden')

    this.intervalId = setInterval(() => {
      this.rotateToNext()
    }, this.intervalValue)
  }

  stopRotation() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  rotateToNext() {
    // 現在のスライドを非表示
    this.slides[this.currentIndex].classList.add('hidden')
    this.slides[this.currentIndex].classList.remove('visible')

    // 次のスライドのインデックスを計算
    this.currentIndex = (this.currentIndex + 1) % this.slides.length

    // 次のスライドを表示
    this.slides[this.currentIndex].classList.add('visible')
    this.slides[this.currentIndex].classList.remove('hidden')
  }
}
